<app-modal-base [title]="dialogTitle" [hasSubmit]="false" [cancelType]="'CLOSE'">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer">
      <div class="d-flex flex-column flex-md-row">
        <app-sale-player-association [sale]="data.sale" playerType="REALTOR"
          position="SELLER"></app-sale-player-association>
        <app-sale-player-association [sale]="data.sale" playerType="NOTARY"
          position="SELLER"></app-sale-player-association>
      </div>
      <div class="d-flex flex-column flex-md-row mt-3">
        <app-sale-player-association [sale]="data.sale" playerType="REALTOR"
          position="BUYER"></app-sale-player-association>
        <app-sale-player-association [sale]="data.sale" playerType="NOTARY"
          position="BUYER"></app-sale-player-association>
      </div>

    </div>
  </div>
</ng-template>
